import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  "class": "group-introduction-list select"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = {
  "class": "select-item-type"
};
var _hoisted_4 = {
  "class": "select-item-header"
};
var _hoisted_5 = {
  "class": "left"
};
var _hoisted_6 = {
  "class": "select-item-label"
};
var _hoisted_7 = {
  "class": "select-item-detail"
};
var _hoisted_8 = ["href"];
import { TUITranslateService } from "@tencentcloud/chat-uikit-engine";
import { ref, watchEffect } from "../../../../adapter-vue";
import documentLink from "../../../../utils/documentLink";
import Icon from "../../../common/Icon.vue";
import selectedIcon from "../../../../assets/icon/selected.svg";
import { groupIntroConfig } from "./config";
import { isUniFrameWork } from "../../../../utils/env";
import { TUIGlobal } from "../../../../utils/universal-api";
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    groupType: {
      type: String,
      "default": ''
    }
  },
  emits: ['selectType'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var type = groupIntroConfig;
    var selectType = ref();
    var emit = __emit;
    watchEffect(function () {
      selectType.value = props.groupType;
    });
    var selected = function selected(item) {
      selectType.value = item.type;
      emit('selectType', item.type);
    };
    var openUrl = function openUrl(link) {
      if (!isUniFrameWork) {
        TUIGlobal === null || TUIGlobal === void 0 || TUIGlobal.open(link);
      }
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("ul", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(type), function (item, index) {
        return _openBlock(), _createElementBlock("li", {
          "class": _normalizeClass(["select-item", [_unref(selectType) === item.type && 'selected']]),
          key: index,
          onClick: function onClick($event) {
            return selected(item);
          }
        }, [_createElementVNode("main", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("aside", _hoisted_5, [_createVNode(Icon, {
          "class": "icon",
          file: item.icon
        }, null, 8, ["file"]), _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.".concat(item.label))), 1)]), _unref(selectType) === item.type ? (_openBlock(), _createBlock(Icon, {
          key: 0,
          file: _unref(selectedIcon)
        }, null, 8, ["file"])) : _createCommentVNode("", true)]), _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.".concat(item.detail))), 1), _createElementVNode("a", {
          "class": "link",
          href: _unref(documentLink).product.url,
          target: "_blank",
          onClick: _cache[0] || (_cache[0] = function ($event) {
            return openUrl(_unref(documentLink).product.url);
          })
        }, _toDisplayString(_unref(TUITranslateService).t("TUIGroup.".concat(item.src))), 9, _hoisted_8)])], 10, _hoisted_2);
      }), 128))]);
    };
  }
});